module.exports = __webpack_public_path__ + "img/car-icon-img.0823dfc2.svg";